import { Checkbox, FormControlLabel } from '@mui/material';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type ConfirmCheckboxProps = {
  fieldName: string;
  translationKey: string;
};

export const ConfirmCheckbox = ({
  fieldName,
  translationKey,
}: ConfirmCheckboxProps): JSX.Element => {
  const { t } = useTranslation();
  const { control, formState, getValues, setValue } = useFormContext();

  useEffect(() => {
    const fieldValue = getValues(fieldName);
    if (fieldValue === undefined) {
      setValue(fieldName, false);
    }

    return () => {
      setValue(fieldName, undefined);
    };
  }, [fieldName, getValues, setValue]);

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }): JSX.Element => {
        return (
          <FormControlLabel
            control={
              <Checkbox
                name={fieldName}
                checked={Boolean(field.value)}
                onChange={(event) => field.onChange(event.target.checked)}
                sx={{
                  color: formState.errors[fieldName] ? 'error.main' : undefined,
                }}
              />
            }
            label={t(translationKey)}
            sx={{
              color: formState.errors[fieldName] ? 'error.main' : undefined,
            }}
          />
        );
      }}
    />
  );
};
